import { keepPreviousData, useQuery } from '@tanstack/react-query';
import * as Mappers from '../mappers';
import * as Queries from '../queries';
import * as Types from '../types';

interface IProps {
  params?: Types.IApi.List.Params;
  enabled?: boolean;
  keepPrevious?: boolean;
}

const useList = ({ params, enabled = true, keepPrevious = false }: IProps = {}) => {
  const initialData = { items: [], meta: Mappers.Meta(), subjects: [] } as Types.IQuery.List;

  const { data = initialData, ...args } = useQuery<Types.IQuery.List>({
    queryKey: ['result', 'list', JSON.stringify(params)],
    queryFn: Queries.List({ params })[1],
    enabled,
    placeholderData: keepPrevious ? keepPreviousData : undefined,
  });

  return { ...args, ...data };
};

export default useList;
